import styled from "styled-components/macro";

export const FooterWrapper = styled.div`
  background-color: rgb(20, 20, 20);
  height: 252px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
`;

export const FooterContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 800px;
  margin: 0 auto;
  width: 100%;
  margin-top: 20px;
`;

export const FooterConditions = styled.div``;

export const SocialIcons = styled.div`
  display: flex;
  gap: 15px;
`;

export const Logo = styled.img`
  width: 100px;
`;

export const SocialIcon = styled.img`
  width: 40px;
  height: 40px;
`;

export const Hr = styled.hr`
  background-color: rgb(255, 255, 255);
  opacity: 0.05;
  height: 1px;
  width: 100%;
  max-width: 800px;
  margin-top: 20px;
`;

export const Conditions = styled.div`
  font-size: 16px;
  font-family: "Poppins";
  font-weight: 500;
  color: rgb(127, 127, 127);
  margin-top: auto;
  max-width: 100%;
`;
